import React from 'react';
import './SiteHeader.css';

export function SiteHeader({ onNavigate, usuario }) {
  const handleNavClick = (e, target) => {
    e.preventDefault();
    if (target === 'agendamento' || target === 'login' || target === 'erp') {
      onNavigate(target);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else if (target === 'home') {
      onNavigate('site');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      onNavigate('site');
      setTimeout(() => {
        const el = document.getElementById(target);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  return (
    <header className="site-header">
      <div className="site-header-container">
        <a href="#home" onClick={(e) => handleNavClick(e, 'home')} className="site-logo">
          <span className="site-logo-icon">✨</span> Fran Beauty
        </a>

        <nav className="site-nav">
          <a href="#sobre" onClick={(e) => handleNavClick(e, 'sobre')} className="site-nav-link">
            Um pouco sobre mim
          </a>
          <a href="#procedimentos" onClick={(e) => handleNavClick(e, 'procedimentos')} className="site-nav-link">
            Procedimentos & Valores
          </a>
          <button
            type="button"
            onClick={(e) => handleNavClick(e, 'agendamento')}
            className="site-nav-link site-nav-btn"
          >
            📅 Agendar Horário
          </button>
          <button
            type="button"
            onClick={(e) => handleNavClick(e, usuario ? 'erp' : 'login')}
            className="site-nav-cta"
          >
            {usuario ? '📊 Acessar ERP (Painel)' : '🔐 Acessar ERP'}
          </button>
        </nav>
      </div>
    </header>
  );
}
